module.exports = __webpack_public_path__ + "img/logo-heart-cross.42e9735.svg";